(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cart-page-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-key');
        var qty = parseInt(this.getAttribute('data-qty'), 10);
        if (qty < 0) qty = 0;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"]) return;
  try {
    
    (function () {
      var mqDrawer = window.matchMedia('(max-width: 767px)');
      var sidebarEl = document.getElementById('cg-sidebar');
      var drawerEl = document.getElementById('cg-sidebar-drawer');
      var backdropEl = document.getElementById('cg-drawer-backdrop');
      var filterOpenBtn = document.getElementById('cg-filter-open');
      var drawerCloseBtn = document.getElementById('cg-drawer-close');
  
      function syncDrawerAriaMobile() {
        if (!drawerEl || !filterOpenBtn || !backdropEl) return;
        if (mqDrawer.matches) {
          var open = sidebarEl && sidebarEl.classList.contains('cg__sidebar--drawer-open');
          drawerEl.setAttribute('aria-hidden', open ? 'false' : 'true');
          backdropEl.setAttribute('aria-hidden', open ? 'false' : 'true');
          filterOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        } else {
          drawerEl.removeAttribute('aria-hidden');
          backdropEl.setAttribute('aria-hidden', 'true');
          filterOpenBtn.setAttribute('aria-expanded', 'false');
        }
      }
  
      function openFilterDrawer() {
        if (!sidebarEl) return;
        sidebarEl.classList.add('cg__sidebar--drawer-open');
        document.body.style.overflow = 'hidden';
        syncDrawerAriaMobile();
      }
  
      function closeFilterDrawer() {
        if (!sidebarEl) return;
        sidebarEl.classList.remove('cg__sidebar--drawer-open');
        document.body.style.overflow = '';
        syncDrawerAriaMobile();
      }
  
      if (filterOpenBtn && drawerEl && sidebarEl) {
        filterOpenBtn.addEventListener('click', function () {
          if (!mqDrawer.matches) return;
          openFilterDrawer();
        });
      }
  
      if (drawerCloseBtn) {
        drawerCloseBtn.addEventListener('click', function () {
          closeFilterDrawer();
        });
      }
  
      if (backdropEl) {
        backdropEl.addEventListener('click', function () {
          closeFilterDrawer();
        });
      }
  
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mqDrawer.matches && sidebarEl && sidebarEl.classList.contains('cg__sidebar--drawer-open')) {
          closeFilterDrawer();
        }
      });
  
      mqDrawer.addEventListener('change', function () {
        if (!mqDrawer.matches) {
          closeFilterDrawer();
        }
        syncDrawerAriaMobile();
      });
  
      syncDrawerAriaMobile();
  
      var mqFilterGroupsDesktop = window.matchMedia('(min-width: 768px)');
      function syncFilterGroupsOpenDefault() {
        document.querySelectorAll('.cg__filter-group').forEach(function (detail) {
          detail.open = mqFilterGroupsDesktop.matches;
        });
      }
      syncFilterGroupsOpenDefault();
      mqFilterGroupsDesktop.addEventListener('change', syncFilterGroupsOpenDefault);
  
      var sortDropdown = document.getElementById('cg-sort-dropdown');
      var sortTrigger = document.getElementById('cg-sort-trigger');
      var sortPanel = document.getElementById('cg-sort-panel');
      var sortCurrent = document.getElementById('cg-sort-current');
  
      if (sortTrigger && sortPanel) {
        sortTrigger.addEventListener('click', function () {
          var isOpen = sortDropdown.classList.toggle('cg__sort-dropdown--open');
          sortTrigger.setAttribute('aria-expanded', isOpen);
          sortPanel.setAttribute('aria-hidden', !isOpen);
        });
  
        document.addEventListener('click', function (e) {
          if (!sortDropdown.contains(e.target)) {
            sortDropdown.classList.remove('cg__sort-dropdown--open');
            sortTrigger.setAttribute('aria-expanded', 'false');
            sortPanel.setAttribute('aria-hidden', 'true');
          }
        });
  
        sortPanel.querySelectorAll('[data-sort-radio]').forEach(function (radio) {
          radio.addEventListener('change', function () {
            var url = new URL(window.location.href);
            url.searchParams.set('sort_by', this.value);
            window.location.href = url.toString();
          });
        });
      }
  
      document.querySelectorAll('[data-filter-check]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var url = new URL(window.location.href);
          var name = this.name;
          var val = this.value;
          var existing = url.searchParams.getAll(name);
          url.searchParams.delete(name);
          if (this.checked) {
            existing.push(val);
          } else {
            existing = existing.filter(function (v) { return v !== val; });
          }
          existing.forEach(function (v) { url.searchParams.append(name, v); });
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      });
  
      document.querySelectorAll('[data-filter-price-range]').forEach(function (rangeWrap) {
        var minParam = rangeWrap.dataset.minParam;
        var maxParam = rangeWrap.dataset.maxParam;
        var minInput = document.querySelector('[name="' + minParam + '"]');
        var maxInput = document.querySelector('[name="' + maxParam + '"]');
        var minSlider = rangeWrap.querySelector('[data-filter-slider-min]');
        var maxSlider = rangeWrap.querySelector('[data-filter-slider-max]');
        var activeTrack = rangeWrap.querySelector('.cg__price-track-active');
        if (!minInput || !maxInput || !minSlider || !maxSlider || !activeTrack) return;
  
        var sliderScale = 100;
        var displayStep = 10;
        var sliderStep = Math.max(1, Math.round(displayStep * sliderScale));
  
        minSlider.step = sliderStep;
        maxSlider.step = sliderStep;
  
        function fromCents(centsValue) {
          return Number(centsValue) / sliderScale;
        }
  
        function toCents(displayValue) {
          return Math.round(Number(displayValue) * sliderScale);
        }
  
        function parseDollars(value, fallback) {
          var cleaned = String(value || '').replace(/[^0-9.]/g, '');
          var num = parseFloat(cleaned);
          return Number.isNaN(num) ? fallback : num;
        }
  
        function formatDollars(value) {
          return '$' + Number(value).toFixed(2);
        }
  
        function updateActiveTrack() {
          var min = Number(minSlider.min);
          var max = Number(minSlider.max);
          var lo = Number(minSlider.value);
          var hi = Number(maxSlider.value);
          var left = ((lo - min) / (max - min)) * 100;
          var right = ((hi - min) / (max - min)) * 100;
          activeTrack.style.left = left + '%';
          activeTrack.style.width = (right - left) + '%';
        }
  
        function syncFromInputs() {
          var lo = parseDollars(minInput.value, fromCents(minSlider.min));
          var hi = parseDollars(maxInput.value, fromCents(maxSlider.max));
          if (lo > hi) lo = hi;
          if (hi < lo) hi = lo;
          minInput.value = formatDollars(lo);
          maxInput.value = formatDollars(hi);
          minSlider.value = toCents(lo);
          maxSlider.value = toCents(hi);
          updateActiveTrack();
        }
  
        function applyUrl() {
          var url = new URL(window.location.href);
          var lo = parseDollars(minInput.value, fromCents(minSlider.min));
          var hi = parseDollars(maxInput.value, fromCents(maxSlider.max));
          url.searchParams.set(minParam, String(toCents(lo)));
          url.searchParams.set(maxParam, String(toCents(hi)));
          url.searchParams.delete('page');
          window.location.href = url.toString();
        }
  
        minSlider.addEventListener('input', function () {
          if (Number(minSlider.value) > Number(maxSlider.value)) minSlider.value = maxSlider.value;
          minInput.value = formatDollars(fromCents(minSlider.value));
          updateActiveTrack();
        });
  
        maxSlider.addEventListener('input', function () {
          if (Number(maxSlider.value) < Number(minSlider.value)) maxSlider.value = minSlider.value;
          maxInput.value = formatDollars(fromCents(maxSlider.value));
          updateActiveTrack();
        });
  
        minSlider.addEventListener('change', applyUrl);
        maxSlider.addEventListener('change', applyUrl);
        minInput.addEventListener('change', function () { syncFromInputs(); applyUrl(); });
        maxInput.addEventListener('change', function () { syncFromInputs(); applyUrl(); });
  
        var currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.has(minParam)) {
          minInput.value = formatDollars(fromCents(Number(currentUrl.searchParams.get(minParam))));
        }
        if (currentUrl.searchParams.has(maxParam)) {
          maxInput.value = formatDollars(fromCents(Number(currentUrl.searchParams.get(maxParam))));
        }
  
        syncFromInputs();
        updateActiveTrack();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-locations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const iframe = root.querySelector('.contact-locations__map-iframe');
      const map = root.querySelector('.contact-locations__map');
      const cardsWrap = root.querySelector('.contact-locations__cards');
      const cards = Array.from(root.querySelectorAll('[data-contact-locations-card]'));
      if (!iframe || !map || !cardsWrap || cards.length === 0) return;

      const setActive = (card) => {
        cards.forEach((c) => c.classList.toggle('is-active', c === card));
        const src = card.getAttribute('data-map-embed') || '';
        if (src && iframe.getAttribute('src') !== src) iframe.setAttribute('src', src);
      };

      const isInteractiveTarget = (target) => Boolean(target.closest('a, button, input, textarea, select, summary'));

      const syncMapHeight = () => {
        const desktop = window.matchMedia('(min-width: 1025px)').matches;
        if (!desktop) {
          map.style.height = '';
          return;
        }

        const h = cardsWrap.getBoundingClientRect().height;
        if (h > 0) map.style.height = `${Math.round(h)}px`;
      };

      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (isInteractiveTarget(e.target)) return;
          setActive(card);
        });

        card.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          if (isInteractiveTarget(e.target)) return;
          e.preventDefault();
          setActive(card);
        });
      });

      setActive(cards[0]);
      syncMapHeight();

      let raf = 0;
      const scheduleSync = () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(syncMapHeight);
      };

      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => scheduleSync());
        ro.observe(cardsWrap);
      } else {
        window.addEventListener('resize', scheduleSync);
      }
    };

    const initAll = () => {
      document.querySelectorAll('[data-contact-locations]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target) return;
      const root = event.target.querySelector('[data-contact-locations]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["distributors-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDistributorsSection(root) {
      if (root.dataset.distributorsInit === 'true') return;
      root.dataset.distributorsInit = 'true';

      var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
      var items = root.querySelectorAll('.distributors-section__item');
      items.forEach(function (item) {
        var trigger = item.querySelector('.distributors-section__trigger');
        var content = item.querySelector('.distributors-section__content');
        if (!trigger || !content) return;
        trigger.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');

          if (allowMultiple) {
            if (wasOpen) {
              item.classList.remove('is-open');
              trigger.setAttribute('aria-expanded', 'false');
              content.hidden = true;
            } else {
              item.classList.add('is-open');
              trigger.setAttribute('aria-expanded', 'true');
              content.hidden = false;
            }
            return;
          }

          root.querySelectorAll('.distributors-section__item').forEach(function (other) {
            other.classList.remove('is-open');
            var t = other.querySelector('.distributors-section__trigger');
            var c = other.querySelector('.distributors-section__content');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (c) c.hidden = true;
          });
          if (!wasOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            content.hidden = false;
          }
        });
      });
    }

    document.querySelectorAll('[data-distributors-section]').forEach(initDistributorsSection);
    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-distributors-section]');
      if (el) {
        el.dataset.distributorsInit = 'false';
        initDistributorsSection(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedAttr = 'data-featured-product-initialized';

    const initFeaturedProduct = (section) => {
      if (!section || section.hasAttribute(initializedAttr)) return;

      const track = section.querySelector('[data-featured-product-track]');
      const prev = section.querySelector('[data-featured-product-prev]');
      const next = section.querySelector('[data-featured-product-next]');
      if (!track || !prev || !next) return;

      section.setAttribute(initializedAttr, 'true');

      const getStep = () => {
        const card = track.querySelector('.featured-product__card');
        if (!card) return 0;
        const cardRect = card.getBoundingClientRect();
        const trackStyles = window.getComputedStyle(track);
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0);
        return cardRect.width + gap;
      };

      const getMaxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);

      const updateNavState = () => {
        const maxScroll = getMaxScroll();
        const current = track.scrollLeft;
        prev.disabled = current <= 2;
        next.disabled = current >= maxScroll - 2;
      };

      const refreshNavState = () => {
        requestAnimationFrame(updateNavState);
      };

      const scrollByStep = (direction) => {
        const step = getStep();
        if (step <= 0) return;
        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByStep(-1));
      next.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', refreshNavState);
      window.addEventListener('load', refreshNavState);

      track.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', refreshNavState, { once: true });
      });

      refreshNavState();
      setTimeout(refreshNavState, 120);
    };

    const initAll = () => {
      document.querySelectorAll('.shopify-section .featured-product').forEach((featuredSection) => {
        const shopifySection = featuredSection.closest('.shopify-section');
        initFeaturedProduct(shopifySection);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var initAttr = 'data-footer-newsletter-initialized';

    function closeFooterNewsletterPopup(popup) {
      if (!popup || popup.hidden) return;
      popup.hidden = true;
      document.body.style.overflow = '';
      var footerEl = popup.closest('footer.footer');
      var openBtn = footerEl && footerEl.querySelector('[data-footer-newsletter-open]');
      if (openBtn) {
        openBtn.focus();
      }
    }

    if (!window.__footerNewsletterEscape) {
      window.__footerNewsletterEscape = true;
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var popup = document.querySelector('.footer-newsletter-popup:not([hidden])');
        closeFooterNewsletterPopup(popup);
      });
    }

    function initFooterNewsletter(footerEl) {
      if (!footerEl || footerEl.getAttribute(initAttr) === 'true') return;

      var popup = footerEl.querySelector('[data-footer-newsletter-popup]');
      var openBtn = footerEl.querySelector('[data-footer-newsletter-open]');
      var closeBtn = popup ? popup.querySelector('[data-footer-newsletter-close]') : null;
      if (!popup || !openBtn || !closeBtn) return;

      footerEl.setAttribute(initAttr, 'true');

      function openPopup() {
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }

      function closePopup() {
        closeFooterNewsletterPopup(popup);
      }

      openBtn.addEventListener('click', openPopup);
      closeBtn.addEventListener('click', closePopup);

      popup.addEventListener('click', function (event) {
        if (event.target === popup) {
          closePopup();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('footer.footer').forEach(initFooterNewsletter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var footerEl = event.target.querySelector && event.target.querySelector('footer.footer');
      if (footerEl) {
        footerEl.removeAttribute(initAttr);
        initFooterNewsletter(footerEl);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('header');
    var toggle = header && header.querySelector('.header-menu-toggle');
    var drawer = header && document.getElementById('header-drawer');
    var backdrop = drawer && drawer.querySelector('.header-drawer-backdrop');
    var drawerClose = drawer && drawer.querySelector('.header-drawer-close');
    var megaTriggers = header && header.querySelectorAll('[data-mega-trigger] a[data-mega-key]');
    var megaPanel = document.getElementById('header-mega-panel');
    var searchToggle = header && header.querySelector('[data-search-toggle]');
    var searchPanel = document.getElementById('header-search-panel');
    var searchDialog = searchPanel && searchPanel.querySelector('.header-search-panel');
    var searchInput = searchPanel && searchPanel.querySelector('.header-search-form input[name="q"]');
    var popularList = header && header.querySelector('[data-popular-searches]');
    var searchCloseTargets = searchPanel && searchPanel.querySelectorAll('[data-search-close]');
    var popularSearchesKey = 'sklo-popular-searches';
    var activeMegaKey = '';

    if (!header || !toggle || !drawer) return;

    function applyMegaTileFragments() {
      header.querySelectorAll('.header-mega-tile[data-link-fragment]').forEach(function (a) {
        var frag = a.getAttribute('data-link-fragment');
        if (!frag) return;
        var base = a.getAttribute('href');
        if (!base || base === '#') return;
        base = base.split('#')[0];
        a.setAttribute('href', base + '#' + frag);
      });
    }
    applyMegaTileFragments();

    var closeMega = function () {};
    var closeSearch = function () {};

    function parsePopularStore() {
      try {
        var stored = JSON.parse(window.localStorage.getItem(popularSearchesKey) || '{}');
        if (!stored || typeof stored !== 'object' || Array.isArray(stored)) {
          return {};
        }
        return stored;
      } catch (error) {
        return {};
      }
    }

    function writePopularStore(data) {
      try {
        window.localStorage.setItem(popularSearchesKey, JSON.stringify(data));
      } catch (error) {
        return;
      }
    }

    function normalizeSearchTerm(term) {
      if (!term) return '';
      return term.replace(/\s+/g, ' ').trim();
    }

    function recordSearchTerm(term) {
      var normalized = normalizeSearchTerm(term);
      if (!normalized) return;
      var store = parsePopularStore();
      store[normalized] = (store[normalized] || 0) + 1;
      writePopularStore(store);
    }

    function getFallbackPopularTerms() {
      if (!popularList) return [];
      var source = popularList.getAttribute('data-fallback-terms') || '';
      if (!source) return [];
      return source.split('|').map(function (item) {
        return normalizeSearchTerm(item);
      }).filter(Boolean);
    }

    function renderPopularSearches() {
      if (!popularList) return;
      var store = parsePopularStore();
      var topTerms = Object.keys(store).sort(function (a, b) {
        var countDiff = store[b] - store[a];
        if (countDiff !== 0) return countDiff;
        return a.localeCompare(b);
      }).slice(0, 5);
      if (!topTerms.length) {
        topTerms = getFallbackPopularTerms().slice(0, 5);
      }

      popularList.innerHTML = '';
      topTerms.forEach(function (term) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        var searchBaseUrl = popularList.getAttribute('data-search-url') || '/search';
        link.href = searchBaseUrl + '?q=' + encodeURIComponent(term);
        link.textContent = term;
        li.appendChild(link);
        popularList.appendChild(li);
      });
    }

    if (megaTriggers && megaTriggers.length && megaPanel) {
      function setActiveMega(key) {
        activeMegaKey = key || '';
        var hasMatch = false;
        megaPanel.querySelectorAll('.header-mega-box[data-mega-key]').forEach(function (box) {
          var isActive = box.getAttribute('data-mega-key') === activeMegaKey;
          box.style.display = isActive ? 'flex' : 'none';
          if (isActive) hasMatch = true;
        });
        if (!hasMatch) {
          closeMega();
        }
      }

      function openMega(key) {
        setActiveMega(key);
        if (!activeMegaKey) return;
        header.classList.add('header--mega-open');
        megaPanel.setAttribute('aria-hidden', 'false');
      }

      closeMega = function () {
        header.classList.remove('header--mega-open');
        megaPanel.setAttribute('aria-hidden', 'true');
        megaPanel.querySelectorAll('.header-mega-box[data-mega-key]').forEach(function (box) {
          box.style.display = 'none';
        });
        activeMegaKey = '';
      };

      megaTriggers.forEach(function (triggerLink) {
        triggerLink.addEventListener('mouseenter', function () {
          openMega(triggerLink.getAttribute('data-mega-key'));
        });
      });

      megaPanel.addEventListener('mouseenter', function () {
        if (activeMegaKey) openMega(activeMegaKey);
      });

      // Tutup saat hover menu lain di nav
      var navLinks = header.querySelectorAll('.header-nav a');
      navLinks.forEach(function (link) {
        if (!link.hasAttribute('data-mega-key')) {
          link.addEventListener('mouseenter', closeMega);
        }
      });

      // Tutup ketika mouse keluar dari header (fallback)
      header.addEventListener('mouseleave', function (e) {
        if (!megaPanel.contains(e.relatedTarget)) {
          closeMega();
        }
      });
    }

    if (searchToggle && searchPanel) {
      function openSearch() {
        closeMega();
        closeMenu();
        header.classList.add('header--search-open');
        searchPanel.setAttribute('aria-hidden', 'false');
        searchToggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('header--search-open');
        renderPopularSearches();
        if (searchInput) {
          setTimeout(function () {
            searchInput.focus();
            searchInput.select();
          }, 10);
        }
      }

      closeSearch = function () {
        header.classList.remove('header--search-open');
        searchPanel.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('header--search-open');
      };

      searchToggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (header.classList.contains('header--search-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });

      searchCloseTargets.forEach(function (closeTarget) {
        closeTarget.addEventListener('click', closeSearch);
      });

      document.addEventListener('click', function (event) {
        if (!header.classList.contains('header--search-open')) return;
        if (!searchDialog) return;
        if (searchDialog.contains(event.target) || searchToggle.contains(event.target)) return;
        closeSearch();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeSearch();
          closeMega();
          closeMenu();
        }
      });

      header.querySelectorAll('.header-nav a').forEach(function (navLink) {
        navLink.addEventListener('mouseenter', closeSearch);
      });
    }

    function scrollToHashTarget() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var id = decodeURIComponent(hash.slice(1));
      var el = document.getElementById(id);
      if (!el) return;
      el.scrollIntoView({ block: 'start' });
    }

    function scheduleHashScroll() {
      scrollToHashTarget();
      requestAnimationFrame(function () {
        scrollToHashTarget();
        setTimeout(scrollToHashTarget, 50);
        setTimeout(scrollToHashTarget, 200);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      applyMegaTileFragments();
      scheduleHashScroll();
      renderPopularSearches();
    });
    window.addEventListener('load', function () {
      if (window.location.hash) scrollToHashTarget();
    });
    window.addEventListener('hashchange', scrollToHashTarget);

    header.querySelectorAll('.header-mega-tile').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        applyMegaTileFragments();
        var url;
        try {
          url = new URL(tile.href);
        } catch (err) {
          return;
        }
        var hash = url.hash;
        if (!hash || hash.length < 2) {
          var df = tile.getAttribute('data-link-fragment');
          if (df) {
            try {
              url = new URL(tile.getAttribute('href').split('#')[0], window.location.origin);
              url.hash = '#' + df;
            } catch (err2) {
              return;
            }
            hash = url.hash;
          }
        }
        if (!hash || hash.length < 2) return;
        var id = decodeURIComponent(hash.slice(1));
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        closeMega();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.pushState) {
          history.pushState(null, '', url.pathname + url.search + url.hash);
        }
      });
    });

    function openMenu() {
      closeSearch();
      header.classList.add('header--menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      header.classList.remove('header--menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (header.classList.contains('header--menu-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (backdrop) {
      backdrop.addEventListener('click', closeMenu);
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeMenu);
    }

    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var searchInput = form.querySelector('input[name="q"]');
        if (!searchInput) return;
        recordSearchTerm(searchInput.value);
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 749) closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["physical-retailers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedAttr = 'data-physical-retailers-initialized';

    const activateTab = (tabsRoot, tabIndex) => {
      const tabs = tabsRoot.querySelectorAll('[data-physical-retailers-tab]');
      const panels = tabsRoot.querySelectorAll('[data-physical-retailers-tabpanel]');

      tabs.forEach((tab) => {
        const isActive = tab.dataset.tabIndex === tabIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.tabIndex === tabIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    };

    const resetTabsInPanel = (panel) => {
      panel.querySelectorAll('[data-physical-retailers-tabs]').forEach((tabsRoot) => {
        const firstTab = tabsRoot.querySelector('[data-physical-retailers-tab]');
        if (firstTab) {
          activateTab(tabsRoot, firstTab.dataset.tabIndex);
        }
      });
    };

    const initCarousel = (root) => {
      const track = root.querySelector('[data-physical-retailers-track]');
      const prev = root.querySelector('[data-physical-retailers-prev]');
      const next = root.querySelector('[data-physical-retailers-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const card = track.querySelector('.physical-retailers__card');
        if (!card) return 0;
        const trackStyles = window.getComputedStyle(track);
        const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0) || 24;
        return card.getBoundingClientRect().width + gap;
      };

      const updateNav = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const tolerance = 2;
        const hideNav = maxScroll <= tolerance;
        prev.disabled = hideNav || track.scrollLeft <= tolerance;
        next.disabled = hideNav || track.scrollLeft >= maxScroll - tolerance;
      };

      const scrollByStep = (direction) => {
        const step = getStep();
        if (step <= 0) return;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      prev.addEventListener('click', () => scrollByStep(-1));
      next.addEventListener('click', () => scrollByStep(1));
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      track.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', updateNav, { once: true });
      });
      updateNav();
      setTimeout(updateNav, 120);
    };

    const initSection = (shopifySection) => {
      const root = shopifySection.querySelector('[data-physical-retailers]');
      if (!root || shopifySection.hasAttribute(initializedAttr)) return;

      shopifySection.setAttribute(initializedAttr, 'true');
      initCarousel(root);

      const popup = root.querySelector('[data-physical-retailers-popup]');
      const closeBtn = root.querySelector('[data-physical-retailers-close]');
      const openButtons = root.querySelectorAll('[data-physical-retailers-open]');
      const panels = root.querySelectorAll('[data-physical-retailers-panel]');

      if (!popup || !closeBtn) return;

      let activePanel = null;

      const closePopup = () => {
        popup.hidden = true;
        document.body.style.overflow = '';
        panels.forEach((panel) => {
          panel.hidden = true;
        });
        activePanel = null;
      };

      const openPopup = (retailerId) => {
        const panel = root.querySelector(`[data-physical-retailers-panel="${retailerId}"]`);
        if (!panel) return;

        panels.forEach((item) => {
          item.hidden = item !== panel;
        });
        resetTabsInPanel(panel);
        activePanel = panel;
        const title = panel.querySelector('.physical-retailers__panel-name');
        if (title) {
          popup.querySelector('.physical-retailers__dialog').setAttribute('aria-labelledby', title.id);
        }
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      };

      openButtons.forEach((button) => {
        button.addEventListener('click', () => {
          openPopup(button.getAttribute('data-physical-retailers-open'));
        });
      });

      closeBtn.addEventListener('click', closePopup);

      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          closePopup();
        }
      });

      root.querySelectorAll('[data-physical-retailers-tabs]').forEach((tabsRoot) => {
        tabsRoot.querySelectorAll('[data-physical-retailers-tab]').forEach((tab) => {
          tab.addEventListener('click', () => {
            activateTab(tabsRoot, tab.dataset.tabIndex);
          });
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.hidden) {
          closePopup();
        }
      });
    };

    const initAll = () => {
      document.querySelectorAll('.shopify-section').forEach((shopifySection) => {
        if (shopifySection.querySelector('[data-physical-retailers]')) {
          initSection(shopifySection);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target) {
        initSection(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-brand-story"]) return;
  try {
    
  (() => {
    const initCarousel = (root) => {
      if (!root || root.dataset.carouselInit === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-pdp-brand-slide]'));
      const prev = root.querySelector('[data-pdp-brand-prev]');
      const next = root.querySelector('[data-pdp-brand-next]');
      if (!slides.length || !prev || !next) return;

      root.dataset.carouselInit = 'true';
      let currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (currentIndex < 0) currentIndex = 0;

      const update = () => {
        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === currentIndex);
        });
        const isSingle = slides.length < 2;
        prev.disabled = isSingle;
        next.disabled = isSingle;
      };

      prev.addEventListener('click', () => {
        if (slides.length < 2) return;
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        update();
      });

      next.addEventListener('click', () => {
        if (slides.length < 2) return;
        currentIndex = (currentIndex + 1) % slides.length;
        update();
      });

      update();
    };

    const initAll = () => {
      document.querySelectorAll('[data-pdp-brand-story]').forEach((root) => initCarousel(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"]) return;
  try {
    
  (function() {
    var mainMedia = document.querySelector('[data-pdp-main-media]');
    var mainImg = document.querySelector('[data-pdp-main-img]');
    var mainVideo = document.querySelector('[data-pdp-main-video]');
    var gallery = document.querySelector('[data-pdp-gallery]');
    var galleryTrack = document.querySelector('[data-pdp-gallery-track]');
    var galleryPrev = document.querySelector('[data-pdp-gallery-prev]');
    var galleryNext = document.querySelector('[data-pdp-gallery-next]');
    var thumbs = document.querySelectorAll('[data-pdp-gallery-thumb]');

    var showMainImage = function(src, alt) {
      if (!mainImg || !src) return;
      if (mainVideo) {
        mainVideo.innerHTML = '';
        mainVideo.hidden = true;
      }
      mainImg.hidden = false;
      mainImg.src = src;
      if (alt) mainImg.alt = alt;
    };

    var showMainVideo = function(html) {
      if (!mainVideo || !html) return;
      if (mainImg) mainImg.hidden = true;
      mainVideo.hidden = false;
      mainVideo.innerHTML = html;
    };

    var setActiveThumb = function(activeThumb) {
      thumbs.forEach(function(thumb) {
        thumb.classList.toggle('is-active', thumb === activeThumb);
      });
    };

    var selectThumb = function(thumb) {
      if (!thumb) return;
      setActiveThumb(thumb);
      var mediaType = thumb.getAttribute('data-media-type');
      if (mediaType === 'image') {
        showMainImage(thumb.getAttribute('data-full-src'), thumb.getAttribute('data-alt'));
        return;
      }
      showMainVideo(thumb.getAttribute('data-video-html'));
    };

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        selectThumb(thumb);
      });
    });

    var updateGalleryNav = function() {
      if (!galleryTrack || !galleryPrev || !galleryNext) return;
      var maxScroll = galleryTrack.scrollWidth - galleryTrack.clientWidth;
      var current = galleryTrack.scrollLeft;
      galleryPrev.disabled = current <= 2;
      galleryNext.disabled = current >= maxScroll - 2;
      galleryPrev.hidden = false;
      galleryNext.hidden = false;
    };

    if (galleryTrack && galleryPrev && galleryNext) {
      var scrollGallery = function(direction) {
        var step = Math.max(galleryTrack.clientWidth * 0.7, 200);
        galleryTrack.scrollBy({ left: step * direction, behavior: 'smooth' });
      };

      galleryPrev.addEventListener('click', function() { scrollGallery(-1); });
      galleryNext.addEventListener('click', function() { scrollGallery(1); });
      galleryTrack.addEventListener('scroll', updateGalleryNav, { passive: true });
      window.addEventListener('resize', updateGalleryNav);
      updateGalleryNav();
      setTimeout(updateGalleryNav, 120);
    }

    var optionControls = document.querySelectorAll('.pdp-option-row [data-variant-id]');
    var variantInput = document.querySelector('input[name="id"]');
    var priceCurrentEl = document.querySelector('[data-pdp-price-current]');
    var priceCompareEl = document.querySelector('[data-pdp-price-compare]');
    var defaultSrc = mainImg ? mainImg.getAttribute('data-default-src') : '';
    var defaultAlt = mainImg ? mainImg.getAttribute('data-default-alt') : '';

    var setMainImage = function(src, alt) {
      showMainImage(src, alt);
      if (!thumbs.length) return;
      var matched = null;
      thumbs.forEach(function(thumb) {
        if (thumb.getAttribute('data-media-type') !== 'image') return;
        if (thumb.getAttribute('data-full-src') === src) matched = thumb;
      });
      if (matched) setActiveThumb(matched);
    };

    var stockStatus = document.querySelector('[data-pdp-stock-status]');
    var stockLabel = document.querySelector('[data-pdp-stock-label]');
    var stockDot = document.querySelector('[data-pdp-stock-dot]');
    var stockNote = document.querySelector('[data-pdp-stock-note]');
    var addToCartBtn = document.querySelector('[data-pdp-add-to-cart]');
    var labelInStock = stockStatus ? stockStatus.getAttribute('data-label-in-stock') : '';
    var labelPreOrderStatus = stockStatus ? stockStatus.getAttribute('data-label-pre-order') : '';
    var labelOutOfStock = stockStatus ? stockStatus.getAttribute('data-label-out-of-stock') : '';
    var labelStockNoteIn = stockNote ? stockNote.getAttribute('data-label-in-stock') : '';
    var labelStockNotePre = stockNote ? stockNote.getAttribute('data-label-pre-order') : '';
    var labelStockNoteOut = stockNote ? stockNote.getAttribute('data-label-out-of-stock') : '';
    var labelAddToCart = addToCartBtn ? addToCartBtn.getAttribute('data-label-add-to-cart') : '';
    var labelPreOrder = addToCartBtn ? addToCartBtn.getAttribute('data-label-pre-order') : '';

    var setVariantStockState = function(state) {
      var inStock = state === 'in_stock';
      var isPreorder = state === 'preorder';
      var isOut = state === 'out_of_stock';

      if (stockStatus) {
        stockStatus.classList.toggle('pdp-stock-status--sold-out', !inStock);
      }
      if (stockDot) {
        stockDot.hidden = !inStock;
      }
      if (stockLabel) {
        if (isPreorder) stockLabel.textContent = labelPreOrderStatus;
        else if (isOut) stockLabel.textContent = labelOutOfStock;
        else stockLabel.textContent = labelInStock;
      }
      if (stockNote) {
        if (isPreorder) stockNote.textContent = labelStockNotePre;
        else if (isOut) stockNote.textContent = labelStockNoteOut;
        else stockNote.textContent = labelStockNoteIn;
      }
      if (addToCartBtn) {
        addToCartBtn.textContent = inStock ? labelAddToCart : labelPreOrder;
        addToCartBtn.disabled = false;
      }
    };

    optionControls.forEach(function(btn) {
      btn.addEventListener('click', function() {
        optionControls.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        if (variantInput) variantInput.value = this.getAttribute('data-variant-id');
        if (priceCurrentEl) {
          var variantPrice = this.getAttribute('data-variant-price');
          if (variantPrice) priceCurrentEl.textContent = variantPrice;
        }
        if (priceCompareEl && priceCurrentEl) {
          var variantComparePrice = this.getAttribute('data-variant-compare-at-price');
          if (variantComparePrice) {
            priceCompareEl.textContent = variantComparePrice;
            priceCompareEl.hidden = false;
            priceCurrentEl.classList.add('pdp-price--sale');
          } else {
            priceCompareEl.textContent = '';
            priceCompareEl.hidden = true;
            priceCurrentEl.classList.remove('pdp-price--sale');
          }
        }
        var variantImage = this.getAttribute('data-variant-image');
        if (variantImage) {
          setMainImage(variantImage, this.getAttribute('data-variant-alt'));
        } else if (defaultSrc) {
          setMainImage(defaultSrc, defaultAlt);
        }
        setVariantStockState(this.getAttribute('data-variant-stock-state') || 'in_stock');
      });
    });

    var addForm = document.querySelector('.pdp-info-column form[action*="/cart/add"]');
    if (addForm) {
      addForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(addForm);
        var submitBtn = addForm.querySelector('.pdp-add-to-cart');
        if (submitBtn) submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.SkloCartDrawer) {
            window.SkloCartDrawer.refresh(cart);
            window.SkloCartDrawer.open();
          }
          if (submitBtn) submitBtn.disabled = false;
        })
        .catch(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var tabLinks = document.querySelectorAll('.pdp-tab-link');
    var tabPanels = document.querySelectorAll('.pdp-tab-panel');
    tabLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        tabLinks.forEach(function(l) { l.classList.remove('active'); });
        tabPanels.forEach(function(p) { p.classList.remove('active'); });
        this.classList.add('active');
        var target = document.getElementById(this.getAttribute('data-tab'));
        if (target) target.classList.add('active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
  (() => {
    const initializedAttr = 'data-promo-popup-global-initialized';

    const initPromoPopup = (popup) => {
      if (!popup || popup.hasAttribute(initializedAttr)) return;

      const closeBtn = popup.querySelector('[data-promo-close]');
      if (!closeBtn) return;

      popup.setAttribute(initializedAttr, 'true');

      const storageKey = popup.getAttribute('data-promo-storage-key') || 'sklo-promo-popup';
      const autoOpen = popup.getAttribute('data-promo-auto-open') === 'true';
      const frequency = popup.getAttribute('data-promo-auto-open-frequency') || 'once';
      const delayMs =
        Math.max(0, Number(popup.getAttribute('data-promo-auto-open-delay') || 1)) * 1000;

      const getStorage = () => {
        if (frequency === 'session') return window.sessionStorage;
        if (frequency === 'once') return window.localStorage;
        return null;
      };

      const hasBeenDismissed = () => {
        const storage = getStorage();
        if (!storage) return false;
        try {
          return storage.getItem(storageKey) === '1';
        } catch (error) {
          return false;
        }
      };

      const markDismissed = () => {
        const storage = getStorage();
        if (!storage) return;
        try {
          storage.setItem(storageKey, '1');
        } catch (error) {
          // Ignore storage errors
        }
      };

      const openPopup = () => {
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
      };

      const closePopup = () => {
        if (!popup.hidden) {
          markDismissed();
        }
        popup.hidden = true;
        document.body.style.overflow = '';
      };

      closeBtn.addEventListener('click', closePopup);

      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          closePopup();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.hidden) {
          closePopup();
        }
      });

      document.addEventListener('sklo:open-promo-popup', openPopup);

      document.querySelectorAll('[data-promo-open]').forEach((btn) => {
        btn.addEventListener('click', openPopup);
      });

      const shouldAutoOpen =
        autoOpen &&
        !hasBeenDismissed() &&
        !(window.Shopify && window.Shopify.designMode);

      if (shouldAutoOpen) {
        window.setTimeout(openPopup, delayMs);
      }
    };

    const initAll = () => {
      document.querySelectorAll('[data-promo-popup]').forEach(initPromoPopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-promo-open]').forEach((btn) => {
      if (btn.hasAttribute('data-promo-open-bound')) return;
      btn.setAttribute('data-promo-open-bound', 'true');
      btn.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('sklo:open-promo-popup'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(button) {
      if (!button || button.__saleBannerBound) return;
      button.__saleBannerBound = true;
      button.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    function boot() {
      document.querySelectorAll('[data-sale-banner-top]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var button = event.target && event.target.querySelector
        ? event.target.querySelector('[data-sale-banner-top]')
        : null;
      if (button) bind(button);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }

    function parseEnd(raw) {
      if (!raw) return null;
      var cleaned = String(raw).trim();
      if (!cleaned) return null;
      // Allow "YYYY-MM-DD HH:MM" by converting space to T for Date parse.
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(cleaned)) {
        cleaned = cleaned.replace(' ', 'T');
      }
      var t = Date.parse(cleaned);
      if (Number.isNaN(t)) return null;
      return t;
    }

    function tick(root) {
      var endAt = parseEnd(root.getAttribute('data-end'));
      var daysEl = root.querySelector('[data-days]');
      var hoursEl = root.querySelector('[data-hours]');
      var minsEl = root.querySelector('[data-mins]');
      var secsEl = root.querySelector('[data-secs]');
      if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

      if (endAt == null) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        return;
      }

      var diff = endAt - Date.now();
      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        if (root.getAttribute('data-hide-when-ended') === 'true') {
          root.hidden = true;
        }
        return true;
      }

      var totalSecs = Math.floor(diff / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
      return false;
    }

    function init(root) {
      if (root.__saleCountdownBound) return;
      root.__saleCountdownBound = true;
      if (tick(root)) return;
      root.__saleCountdownTimer = window.setInterval(function () {
        if (tick(root)) {
          window.clearInterval(root.__saleCountdownTimer);
        }
      }, 1000);
    }

    function boot() {
      document.querySelectorAll('[data-sale-countdown]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target && event.target.querySelector
        ? event.target.querySelector('[data-sale-countdown]')
        : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-explore"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStoriesExplore(root) {
      if (!root) return;

      var track = root.querySelector('[data-explore-track]');
      var prev = root.querySelector('[data-explore-prev]');
      var next = root.querySelector('[data-explore-next]');
      if (!track || !prev || !next) return;

      function getStep() {
        var first = track.querySelector('.explore-story-card');
        if (!first) return 0;
        var second = first.nextElementSibling;
        if (second && second.classList.contains('explore-story-card')) {
          return second.offsetLeft - first.offsetLeft;
        }
        return first.getBoundingClientRect().width;
      }

      function updateNav() {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var tol = 2;
        prev.disabled = track.scrollLeft <= tol;
        next.disabled = track.scrollLeft >= maxScroll - tol;
        if (maxScroll <= tol) {
          prev.disabled = true;
          next.disabled = true;
        }
      }

      function scrollDir(dir) {
        var step = getStep();
        if (step <= 0) return;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () {
        scrollDir(-1);
      });
      next.addEventListener('click', function () {
        scrollDir(1);
      });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    function initAll() {
      document.querySelectorAll('[data-stories-explore]').forEach(initStoriesExplore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var el = event.target.querySelector('[data-stories-explore]');
      if (el) initStoriesExplore(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
